import { motion } from "framer-motion";

export default function AccessSection() {
  return (
    <section id="access" className="relative w-full py-20 md:py-32 bg-warm-900 overflow-hidden">
      <div className="relative z-10 max-w-[1000px] mx-auto px-6">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="mb-10 md:mb-14"
        >
          <span className="inline-block px-4 py-1.5 text-xs md:text-sm font-sans font-medium tracking-super-wide text-warm-400 bg-warm-800 border border-warm-700 rounded-full mb-4">
            ACCESS
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-warm-100">
            所在地・アクセス
          </h2>
        </motion.div>

        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          {/* Left — Info */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.7 }}
            className="w-full lg:w-1/2"
          >
            <div className="space-y-6 md:space-y-8">
              {/* Business Hours */}
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-xl bg-warm-800 flex items-center justify-center">
                  <i className="ri-time-line text-amber-500 text-lg md:text-xl" />
                </div>
                <div>
                  <p className="text-xs font-sans text-warm-400 mb-1">営業時間</p>
                  <p className="text-lg md:text-xl font-sans font-semibold text-warm-100">
                    20:00 — 翌 4:00
                    <span className="text-xs font-sans font-normal text-warm-400 ml-2">[平日]</span>
                  </p>
                  <p className="text-lg md:text-xl font-sans font-semibold text-warm-100">
                    20:00 — 翌 6:00
                    <span className="text-xs font-sans font-normal text-warm-400 ml-2">[金土祝前日]</span>
                  </p>
                </div>
              </div>

              {/* Holiday */}
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-xl bg-warm-800 flex items-center justify-center">
                  <i className="ri-calendar-close-line text-amber-500 text-lg md:text-xl" />
                </div>
                <div>
                  <p className="text-xs font-sans text-warm-400 mb-1">定休日</p>
                  <p className="text-lg md:text-xl font-sans font-semibold text-warm-100">
                    火曜日
                  </p>
                </div>
              </div>

              {/* Address */}
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-xl bg-warm-800 flex items-center justify-center">
                  <i className="ri-map-pin-line text-amber-500 text-lg md:text-xl" />
                </div>
                <div>
                  <p className="text-xs font-sans text-warm-400 mb-1">住所</p>
                  <p className="text-base md:text-lg font-sans text-warm-100 leading-relaxed">
                    北海道札幌市中央区
                    <br />
                    南4条西5丁目
                    <br />
                    第二観光会館ビル 6F
                  </p>
                </div>
              </div>

              {/* Tel */}
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-xl bg-warm-800 flex items-center justify-center">
                  <i className="ri-phone-line text-amber-500 text-lg md:text-xl" />
                </div>
                <div>
                  <p className="text-xs font-sans text-warm-400 mb-1">お電話</p>
                  <p className="text-base md:text-lg font-sans text-warm-100">
                    070-3985-7570
                  </p>
                  <p className="text-xs font-sans text-warm-500 mt-1">
                    営業時間内にお電話ください
                  </p>
                </div>
              </div>
            </div>

          </motion.div>

          {/* Right — Map */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.7, delay: 0.15 }}
            className="w-full lg:w-1/2"
          >
            <div className="rounded-2xl overflow-hidden border border-warm-800">
              <iframe
                src="https://maps.google.com/maps?q=BAR+beb%C3%A9+%E6%9C%AD%E5%B9%8C&t=&z=17&ie=UTF8&iwloc=&output=embed"
                width="100%"
                height="400"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="BAR bebé 所在地"
                className="w-full h-[300px] md:h-[400px]"
              />
            </div>
            <p className="mt-3 text-sm font-sans text-warm-300">
              地下鉄南北線「すすきの駅」より徒歩約5分
            </p>
            <div className="mt-3 flex flex-col gap-2">
              <a
                href="https://maps.google.com/maps?q=BAR+beb%C3%A9+%E6%9C%AD%E5%B9%8C"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm font-sans text-warm-300 underline hover:text-amber-500 transition-colors duration-300"
              >
                Googleマップで表示する
              </a>
              <a
                href="https://www.google.com/maps/dir/?api=1&destination=BAR+beb%C3%A9+%E6%9C%AD%E5%B9%8C"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm font-sans text-warm-300 underline hover:text-amber-500 transition-colors duration-300"
              >
                経路を調べる
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}